import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { Gradients } from '@/shared/components/theme/gradient';
import { cn } from '@/shared/utils/cn';

const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2 py-[3px] text-4xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: `border-transparent text-secondary-foreground bg-gradient-to-r ${Gradients.greenGradient} shadow hover:bg-primary/80`,
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
        outline: 'text-foreground',
        rounded: 'rounded-full',
        table:
          'rounded-full border-none px-2 py-[3px] bg-[#FEFEFE] text-black text-2xs font-normal',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = ({ className, variant, ...props }: BadgeProps) => {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
};

export { Badge, badgeVariants };
